<template>
  <div class="control-btn-cont">
    <p class="btn-label">{{$t('btns.add')}}</p>
    <button type="button" class="btn btn-control circle-btn btn-green">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.842 9.16663C17.842 9.99996 17.1753 10.6666 16.342 10.6666H10.342V16.3333C10.342 17.1666 9.6753 17.8333 8.84196 17.8333C8.00863 17.8333 7.34196 17.1666 7.34196 16.3333V10.6666H1.67529C0.84196 10.6666 0.175293 9.99996 0.175293 9.16663C0.175293 8.33329 0.84196 7.66663 1.67529 7.66663H7.34196V1.66663C7.34196 0.833293 8.00863 0.166626 8.84196 0.166626C9.6753 0.166626 10.342 0.833293 10.342 1.66663V7.66663H16.342C17.1753 7.66663 17.842 8.33329 17.842 9.16663Z" fill="white"/>
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'btnAdd'
  }
</script>
